// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//usage:   ng build --configuration=development

export const environment = {
  production: false,

 // redirectUri: 'http://localhost:4200',  
 // APIURL: 'https://localhost:5001/api'
  //rekaps
  clientId: '3de56dfb-528c-40e2-9d38-e3b14208044a',
  tenantId: '9107b728-2166-4e5d-8d13-d1ffdf0351ef',
  apiScope: 'api://8ba3b08b-27a3-4695-8de6-c5379b8db42f/access_as_user',
  graphUri: 'https://graph.microsoft.com/v1.0/me',
  redirectUri: 'https://rekaps-dev.toyota.com',  
  APIURL: 'https://api.rekaps-dev.toyota.com/api'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
